import { useNavigate, useParams } from "@solidjs/router"
import { createResource, createSignal, Show } from "solid-js";
import { getRunbook } from "../runbooks";
import { Box, Button, Container, Stack } from "@suid/material";
import { ArrowBack, Print } from "@suid/icons-material";

const RunbookView = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [runbook] = createResource(() => getRunbook(params.id));
  const [language, setLanguage] = createSignal('eng');

  const printContent = () => {
    const content = language() === 'eng' ? runbook().book : runbook().bookUrdu;
    const printWindow = window.open('', '_blank', 'width=800,height=600');

    if (!printWindow) return;

    printWindow.document.title = 'Print';

    const style = printWindow.document.createElement('style');
    style.textContent = `
    body { font-family: sans-serif; padding: 20px; direction: ${language() === 'ur' ? 'rtl' : 'ltr'}; }
  `;
    printWindow.document.head.appendChild(style);

    const container = printWindow.document.createElement('div');
    container.innerHTML = content;
    printWindow.document.body.appendChild(container);

    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 250);
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 6 }}>
      <Button startIcon={<ArrowBack />} onClick={() => navigate(-1)} sx={{ mb: 2 }}>
        Back
      </Button>
      <Show when={runbook()}>
        <Show when={runbook().bookUrdu}>
          <Stack direction='row' justifyContent="space-between">
            <Stack direction='row' gap={1}>
              <Button disabled={language() === 'eng'} onClick={() => setLanguage('eng')}>English</Button>
              <Button disabled={language() === 'ur'} onClick={() => setLanguage('ur')}>Urdu</Button>
            </Stack>

            <Button variant='outlined' startIcon={<Print />} color='success' onClick={printContent}>Print</Button>
          </Stack>

        </Show>
        <Box sx={{ bgcolor: 'grey.50', borderBottomLeftRadius: '5px', borderBottomRightRadius: '5px', p: 1 }}>
          <div innerHTML={language() === 'eng' ? runbook().book : runbook().bookUrdu}></div>
        </Box>
      </Show>
    </Container>
  );
}

export default RunbookView;
